import { render, staticRenderFns } from "./ProductSearchCart.vue?vue&type=template&id=3680f1e3&lang=html&"
import script from "./ProductSearchCart.vue?vue&type=script&lang=js&"
export * from "./ProductSearchCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports